import { IYear } from '../models/year-model';
import { $api } from '../service';

export const getYear = async () => {
  const { data } = await $api.get<IYear>('/year');

  return { year: data };
};
